// SecureStore polyfill for web
// Expo SecureStore doesn't work in web, so we use localStorage as fallback

import { getPlatform } from './platformUtils'

const isWeb = () => getPlatform().OS === 'web'

export const SecureStoreWeb = {
    async getItemAsync(key) {
        if (isWeb()) {
            try {
                const value = localStorage.getItem(`secure_${key}`)
                return value
            } catch (error) {
                console.warn('SecureStoreWeb getItemAsync error:', error)
                return null
            }
        } else {
            // En móvil, usar SecureStore normal
            const SecureStore = require('expo-secure-store')
            return await SecureStore.getItemAsync(key)
        }
    },

    async setItemAsync(key, value) {
        if (isWeb()) {
            try {
                localStorage.setItem(`secure_${key}`, value)
                return
            } catch (error) {
                console.warn('SecureStoreWeb setItemAsync error:', error)
                throw error
            }
        } else {
            // En móvil, usar SecureStore normal
            const SecureStore = require('expo-secure-store')
            return await SecureStore.setItemAsync(key, value)
        }
    },

    async deleteItemAsync(key) {
        if (isWeb()) {
            try {
                localStorage.removeItem(`secure_${key}`)
                return
            } catch (error) {
                console.warn('SecureStoreWeb deleteItemAsync error:', error)
                throw error
            }
        } else {
            // En móvil, usar SecureStore normal
            const SecureStore = require('expo-secure-store')
            return await SecureStore.deleteItemAsync(key)
        }
    }
}

export default SecureStoreWeb